import { Form, Select } from "antd";
import type { ProjectItem, Vendor } from "./types";

interface VendorPartnerSectionProps {
  project: ProjectItem;
  vendors: Vendor[];
  onChange: (updates: Partial<ProjectItem>) => Promise<void> | void;
}

export default function VendorPartnerSection({
  project,
  vendors,
  onChange,
}: VendorPartnerSectionProps) {
  return (
    <Form.Item label="Vendor Partner">
      <Select
        aria-label="Vendor partner selector"
        value={project.vendorName || undefined}
        onChange={(value) => onChange({ vendorName: value })}
        allowClear
        showSearch
        placeholder="Select a vendor partner"
        options={vendors.map((vendor) => ({
          value: vendor.id,
          label: vendor.profile?.split("\n")[0] || vendor.id,
        }))}
        filterOption={(input, option) =>
          (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
        }
      />
    </Form.Item>
  );
}
